<template>
    <div class="rounded-icon-button-wrapper" @click="clicked" :style="wrapperStyle[size]">
        <span :class="['icon', 'icon-' + icon]" :style="Object.assign(iconStyle[size],{color: iconColor})"></span>
    </div>
</template>

<script>
    export default {
        name: "RoundedIconButton",
        props: {
            icon: {
                type: String,
                required: false
            },
            iconColor: {
                type: String,
                required: false,
                default: '#00b6ed'
            },
            size: {
                type: String,
                default: 'small'
            }
        },
        data: function () {
            return {
                iconStyle: {
                    small: {
                        'font-size': '14px'
                    }
                },
                wrapperStyle: {
                    small: {
                        width: '25px',
                        height: '25px'
                    }
                }
            }
        },
        methods: {
            clicked: function () {
                this.$emit('click');
            },
            getImgUrl: function (pic) {
                return require('../../assets/' + pic)
            }
        }
    }

</script>

<style lang="scss" scoped>

    .rounded-icon-button-wrapper {
        background-color: white;
        padding: 4px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

</style>